import '../style/Industrial.css'
import laser_image from '../images/laser_demonstration.png'

import qrcode_ex from '../images/qrcode_ex.webp'
import serial_number_ex from '../images/product_code_ex.webp'
import bar_code_ex from '../images/bar_code_ex.webp'
import lotto_ex from '../images/lotto_ex.webp'
import data_matrix_ex from '../images/data_matrix_ex.webp'
import uid_ex from '../images/uid_ex.webp'
import specifiche_tecniche_ex from '../images/specifiche_tecniche_ex.webp'

import bf_logo_ex from '../images/bf_logo_ex.webp'
import tiger_logo_ex from '../images/tiger_logo_ex.webp'
import redbull_logo_ex from '../images/redbull_logo_ex.webp'
import ferrari_logo_ex from '../images/ferrari_logo_ex.webp'
import hp_logo_ex from '../images/hp_logo_ex.webp'


import metallo from '../images/metallo.webp'
import plastiche from  '../images/plastiche.webp'
import eco from '../images/ecofriendly_logo.png'
import rapid from '../images/rapid_logo.png'
import gear from '../images/gear_logo.png';

export function Industrial() {
    return(
        <>
        <div className="industrial_belly">
            <h1 className='industrial_title'>Marcature a scopo industriale di alta qualità e precisione</h1>
            <h3 className='industrial_description'><span className='bold_gray'>Realizziamo incisioni e marcature laser industriali su metalli e plastiche tecniche utilizzando marcatrice laser a fibra.
            Garantisce precisione, durata nel tempo e alta leggibilità.</span>
            </h3>
            <div className='industrial_box height_1000'>
                <div className='ind_img_container'><img style={{width: '100%', objectFit: 'contain'}} src={laser_image} alt='laser'/></div>
                <div className='ind_text_container'><p className='ind_text'>L'incisione laser industriale è un processo di marcatura permanente <span className='bold_gray'>che utilizza il raggio laser ad alta precisione per incidere o modificare la superficie del materiale.</span></p>
                    <div className='ind_text'>
                        <span>Questa tecnologia permette di ottenere:</span>
                        <ul style={{textAlign: 'left'}}>
                            <li>marcature indelebili</li>
                            <li>precisione fino al decimo di millimetro</li>
                            <li>incisioni resistenti a usura, solventi e calore</li>
                            <li>risultati perfettamente leggibili anche su componenti molto piccoli</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='industrial_title top_margin'>Tipi di incisione che realizziamo</div>
            
            <div className='industrial_box' style={{flexWrap: 'wrap', height: 'fit-content'}}>
                <div className='industrial_box example_box'>
                    <div className='industrial_title'>codici seriali</div>
                    <div className='ind_example'>
                        <div className='ind_text bold_gray'>Numeri di serie</div>
                        <div className='example_img'><img className='img_picture' src={serial_number_ex} alt='numeri di serie'/></div>
                    </div>
                    <div className='ind_example'>
                        <div className='ind_text bold_gray'>Codici lotto</div>
                        <div className='example_img'><img className='img_picture' src={lotto_ex} alt='codici lotto'/></div>
                    </div>
                    <div className='ind_example'>
                        <div className='ind_text bold_gray'>Codici a barre</div>
                        <div className='example_img'><img className='img_picture' src={bar_code_ex} alt='codici a barre'/></div>
                    </div>
                </div>
                <div className='industrial_box example_box'>
                    <div className='industrial_title'>codici bidimensionali</div>
                    <div className='ind_example'>
                        <div className='ind_text bold_gray'>QR code</div>
                        <div className='example_img'><img className='img_picture' src={qrcode_ex} alt='qrcode'/></div>
                    </div>
                    <div className='ind_example'>
                        <div className='ind_text bold_gray'>Data matrix</div>
                        <div className='example_img'><img className='img_picture' src={data_matrix_ex} alt='data matrix'/></div>
                    </div>
                    <div className='ind_example'>
                        <div className='ind_text bold_gray'>Codice UID</div>
                        <div className='example_img'><img className='img_picture' src={uid_ex} alt='codici UID'/></div>
                    </div>
                </div>
                <div className='industrial_box example_box'>
                    <div className='industrial_title'>logo</div>
                    <div className='slider_container'>
                        <div className='slider_track'>
                            <div className='ind_example'>
                                <div className='example_img'>
                                    <img className='img_picture' src={bf_logo_ex} alt='bf'/>
                                </div>
                            </div>
                            <div className='ind_example'>
                                <div className='example_img'>
                                    <img className='img_picture' src={ferrari_logo_ex} alt='ferrari'/>
                                </div>
                            </div>

                            <div className='ind_example'>
                                <div className='example_img'>
                                    <img className='img_picture' src={redbull_logo_ex} alt='redbull'/>
                                </div>
                            </div>
                            <div className='ind_example'>
                                <div className='example_img'>
                                    <img className='img_picture' src={hp_logo_ex} alt='hp'/>
                                </div>
                            </div>

                            <div className='ind_example'>
                                <div className='example_img'>
                                    <img className='img_picture' src={tiger_logo_ex} alt='tiger'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='industrial_box example_box'>
                    <div className='industrial_title'>specifiche</div>
                    <div className='ind_example'>
                        <div className='ind_text bold_gray'>Specifiche tecniche</div>
                        <div className='example_img'><img className='img_picture' src={specifiche_tecniche_ex} alt='specifiche tecniche'/></div>
                    </div>
                </div>
            </div>
            <div className='industrial_title top_margin'>Materiali Lavorabili</div>
            <div className='industrial_box example_box'>
                <div className='industrial_box' style={{backgroundImage: `url(${metallo})`, flexWrap: 'wrap'}}>
                    <h1 className='title_list'>metalli</h1>
                    <ul class="materials_list">
                        <li>Ferro</li>
                        <li>Acciaio / Acciaio inox</li>
                        <li>Alluminio / Alluminio anodizzato</li>
                        <li>Ottone</li>
                        <li>Oro</li>
                        <li>Argento</li>
                        <li>Rame</li>
                        <li>Titanio</li>
                        <li>Metalli verniciati</li>
                    </ul>
                </div>
                <div className='industrial_box' style={{backgroundImage: `url(${plastiche})`, color: 'black', flexWrap: 'wrap'}}>
                    <h1 className='title_list'>plastiche</h1>
                    <ul class="materials_list">
                        <li>ABS</li>
                        <li>Nylon / Poliammide (PA)</li>
                        <li>Policarbonato (PC)</li>
                        <li>POM / Delrin</li>
                        <li>PET e PBT</li>
                        <li>PMMA (acrilico)</li>
                        <li>Polistirene (PS)</li>
                        <li>PEEK</li>
                    </ul>
                </div>
            </div>
            <div className='industrial_title top_margin'>Vantaggi della marcatura laser</div>
            <div className='industrial_box'>
                <ul class="materials_list" style={{display:'flex'}}>
                    <li className='li_style'><div className="li_content">Marcatura permanente</div></li>
                    <li className='li_style'><div className="li_content">Altissima precisione</div></li>
                    <li className='li_style'><div className="li_content">Nessun consumo di inchiostri o solventi<img className='list_icon' src={eco} alt='eco friendly'/></div></li>
                    <li className='li_style'><div className="li_content">Ideale per tracciabilità industriale</div></li>
                    <li className='li_style'><div className="li_content">Perfetta per componenti meccanici e tecnici<img className='list_icon' src={gear} alt='componenti meccanici industriali'/></div></li>
                    <li className='li_style'><div className="li_content">Lavorazione rapida e ripetibile<img className='list_icon' src={rapid} alt='lavoro rapido'/></div></li>
                </ul>
            </div>
        </div>
        </>
    );
}